import React from 'react';
import Heading from '../../01-atoms/text/Heading.component';
import Button from '../../01-atoms/buttons/Button.component';
import bem from '../../_utils/bem';

var Cta = function Cta(_ref) {
  var _ref$block = _ref.block,
      block = _ref$block === void 0 ? 'cta' : _ref$block,
      element = _ref.element,
      modifiers = _ref.modifiers,
      additionalClasses = _ref.additionalClasses,
      heading = _ref.heading,
      buttonModifiers = _ref.buttonModifiers,
      buttonText = _ref.buttonText;
  return /*#__PURE__*/React.createElement("div", {
    className: bem(block, element, modifiers, additionalClasses)
  }, /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    block: block,
    element: "heading"
  }, heading), /*#__PURE__*/React.createElement(Button, {
    block: block,
    element: "button",
    modifiers: buttonModifiers
  }, buttonText));
};

export default Cta;